import { render, staticRenderFns } from "./StepWaste.vue?vue&type=template&id=f6b88638&lang=html&"
import script from "./StepWaste.vue?vue&type=script&lang=js&"
export * from "./StepWaste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports